import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubsistemaComponent } from './components/subsistema/subsistema.component';
import { EspecialDosComponent } from './components/especial-dos/especial-dos.component';
import { ComunesComponent } from './components/comunes/comunes.component';
import { EspecialUnoComponent } from './components/especial-uno/especial-uno.component';
import { UmbralesComponent } from './components/umbrales/umbrales.component';
import { AmbienteComponent } from './components/ambiente/ambiente.component';
import { ConfigPeriodosComponent } from './components/config-periodos/config-periodos.component';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AccessPermisionGuard } from 'src/app/guard/accessPermision.guard';

const routesCataloProces: Routes = [
  {
    path: '',
    children: [
      { path: 'ambientes', component: AmbienteComponent , data:{title:'Ambientes', apps:[ConstantsCatalogosIdService.AMBIENTES]}, canActivate:[AccessPermisionGuard]},
      { path: 'subsistemas', component: SubsistemaComponent, data:{title:'Subsistemas', apps:[ConstantsCatalogosIdService.SUBSISTEMAS]}, canActivate:[AccessPermisionGuard]},
      { path: 'especialdos', component: EspecialDosComponent, data:{title:'Especialdos', apps:[ConstantsCatalogosIdService.CATALOGO_ESPECIAL_DOS]}, canActivate:[AccessPermisionGuard]},
      { path: 'comunes', component: ComunesComponent, data:{title:'Comunes', apps:[ConstantsCatalogosIdService.CATALOGO_COMUN]}, canActivate:[AccessPermisionGuard]},
      { path: 'especialuno', component: EspecialUnoComponent, data:{title:'Especialuno', apps:[ConstantsCatalogosIdService.CATALOGO_ESPECIAL_UNO]}, canActivate:[AccessPermisionGuard]},
      { path: 'umbrales', component: UmbralesComponent , data:{title:'Umbrales', apps:[ConstantsCatalogosIdService.UMBRALES]}, canActivate:[AccessPermisionGuard]},
      { path: '**', redirectTo: 'dashboard' },
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routesCataloProces)],//Para rutas hijas
  exports: [RouterModule]
})

export class CatalogoProcesRouting {

}
